// extracted by mini-css-extract-plugin
export default {"options":"FormatSelectorOptions_options__VvxSc"};